export const liveScheduleActionsMenu = ["Post Schedule"];

export default liveScheduleActionsMenu;